import { fetchAccessToken, makeFetchCall } from './fetch-data';
import urlMapping from '@next-app/config/urlMapping';
import { isBrowser } from './common-utils';

const InitialData = () => {
  return {
    getJson: async ({
      Endeca_user_segments,
      Endeca_date,
      isFurniture = false,
    }: {
      Endeca_user_segments?: string;
      Endeca_date?: string;
      isFurniture?: boolean;
    } = {}) => {
      const queryParams = new URLSearchParams();

      // Add optional parameters if they are provided
      if (Endeca_user_segments)
        queryParams.append('endeca_user_segments', Endeca_user_segments);
      if (Endeca_date) queryParams.append('Endeca_date', Endeca_date);

      const endpoint = `${urlMapping.headerFooterUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

      const headerFooter = await makeFetchCall({
        endpoint: endpoint,
        tags: ['headerFooter'],
        headers: { 'Is-Furniture': isFurniture || false },
      });
      return {
        headerFooter,
      };
    },

    sessionInfoGetJson: async ({
      endecaUserSegments,
      endecaDate,
      searchParams,
      isGSA = '',
      isFurniture = false,
    }: {
      endecaUserSegments?: string;
      endecaDate?: string;
      searchParams?: string;
      isGSA?: string;
      isFurniture?: boolean;
    } = {}) => {
      if (isBrowser()) {
        const accessToken = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');
        const expireDate = localStorage.getItem('expireDate');

        if (
          refreshToken &&
          (!accessToken || (expireDate && Date.now() > Number(expireDate)))
        ) {
          await fetchAccessToken();
        }
      }

      const body: Record<string, string> = {};
      if (endecaUserSegments) body['Endeca_user_segments'] = endecaUserSegments;
      if (endecaDate) body['Endeca_date'] = endecaDate;
      const sessionInfo = await makeFetchCall({
        endpoint: `${urlMapping.sessionInformationUrl}${
          isGSA !== 'true' && searchParams ? `${searchParams}` : ''
        }`,
        options: {
          method: 'POST',
          body: JSON.stringify(body),
          retries: 2,
        },
        headers: { 'Is-Furniture': isFurniture || false },
      });
      if (
        typeof document !== 'undefined' &&
        sessionInfo?.sessionInfo?.cartInfo?.cartId
      ) {
        const cookies = document.cookie.split(';').map((c) => c.trim());
        const hasCartCookie = cookies.some((c) =>
          c.startsWith('CartItems_ll='),
        );
        if (!hasCartCookie) {
          document.cookie = `CartItems_ll=${sessionInfo.sessionInfo.cartInfo.cartId}; path=/`;
        }
      }
      return {
        sessionInfo,
      };
    },
  };
};

export default InitialData();
